import { CommonModule } from '@angular/common';
import { InjectionToken, NgModule } from '@angular/core';
import { UnitsStore } from '../../../@store';
import { DecimalPipeWrapper } from '../../../shared/pipes/decimal-pipe-wrapper/decimal-pipe-wrapper.pipe';
import { ConsumptionChartsUnitsAdaptee } from './adaptees/consumption-charts.adaptee';
import { DefaultUnitsAdaptee } from './adaptees/default-units-adaptee';
import { HemsUnitsAdaptee } from './adaptees/hems.adaptee';
import { RemoteServiceUnitsAdaptee } from './adaptees/remote-service-units.adaptee';
import { TrendingAdaptee } from './adaptees/trending.adaptee';
import { UnitsAdapter } from './units.adapter';
import { UnitsAdapterType } from './units.model';

export const DEFAULT_UNITS_ADAPTER_IT = new InjectionToken<UnitsAdapter>(UnitsAdapterType.Default);
export const CONSTUMPTION_CHARTS_UNITS_ADAPTER_IT = new InjectionToken<UnitsAdapter>(
  UnitsAdapterType.Consumption
);
export const REMOTE_SERVICE_UNITS_ADAPTER_IT = new InjectionToken<UnitsAdapter>(
  UnitsAdapterType.RemoteService
);
export const TRENDING_UNITS_ADAPTER_IT = new InjectionToken<UnitsAdapter>(
  UnitsAdapterType.Trending
);

export const HEMS_UNITS_ADAPTER_IT = new InjectionToken<UnitsAdapter>(UnitsAdapterType.Hems);

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: CONSTUMPTION_CHARTS_UNITS_ADAPTER_IT,
      useFactory: (decmalPipeWrapper, unitsStore): UnitsAdapter =>
        new UnitsAdapter(new ConsumptionChartsUnitsAdaptee(), decmalPipeWrapper, unitsStore),
      deps: [DecimalPipeWrapper, UnitsStore],
    },
    {
      provide: TRENDING_UNITS_ADAPTER_IT,
      useFactory: (decmalPipeWrapper, unitsStore): UnitsAdapter =>
        new UnitsAdapter(new TrendingAdaptee(), decmalPipeWrapper, unitsStore),
      deps: [DecimalPipeWrapper, UnitsStore],
    },
    {
      provide: REMOTE_SERVICE_UNITS_ADAPTER_IT,
      useFactory: (decmalPipeWrapper, unitsStore): UnitsAdapter =>
        new UnitsAdapter(new RemoteServiceUnitsAdaptee(), decmalPipeWrapper, unitsStore),
      deps: [DecimalPipeWrapper, UnitsStore],
    },
    {
      provide: HEMS_UNITS_ADAPTER_IT,
      useFactory: (decmalPipeWrapper, unitsStore): UnitsAdapter =>
        new UnitsAdapter(new HemsUnitsAdaptee(), decmalPipeWrapper, unitsStore),
      deps: [DecimalPipeWrapper, UnitsStore],
    },
    {
      provide: DEFAULT_UNITS_ADAPTER_IT,
      useFactory: (decmalPipeWrapper, unitsStore): UnitsAdapter =>
        new UnitsAdapter(new DefaultUnitsAdaptee(), decmalPipeWrapper, unitsStore),
      deps: [DecimalPipeWrapper, UnitsStore],
    },
    {
      provide: UnitsAdapter,
      useFactory: (decmalPipeWrapper, unitsStore): UnitsAdapter =>
        new UnitsAdapter(new DefaultUnitsAdaptee(), decmalPipeWrapper, unitsStore),
      deps: [DecimalPipeWrapper, UnitsStore],
    },
  ],
})
export class UnitsAdapterModule {}
